<template>
  <div ref="modal" class="modal to-top">
      <div class="modal-background"></div>
      <div class="modal-card">
          <header class="modal-card-head">
            <p class="modal-card-title">{{ $t("QrScanner") }}</p>
          </header>
          <section class="modal-card-body has-text-centered">
            <canvas ref="canvas" style="width:320px; height: 320px"></canvas>
            <p v-html="$t('QrScannerBody', ['<i class=\'fa fa-qrcode\'></i>'])"></p>
          </section>
          <footer class="modal-card-foot has-text-centered">
            <button @click="destroy()" class="button is-info">{{ $t("Cancel") }}</button>
          </footer>
      </div>
  </div>
</template>

<script>
import jsQR from "jsqr";

//input range [-100..100]
const contrastImage = (imgData, contrast) =>
{
    var d = imgData.data;
    contrast = (contrast/100) + 1;  //convert to decimal & shift range: [0..2]
    var intercept = 128 * (1 - contrast);
    for(var i=0;i<d.length;i+=4){   //r,g,b,a
        d[i] = d[i]*contrast + intercept;
        d[i+1] = d[i+1]*contrast + intercept;
        d[i+2] = d[i+2]*contrast + intercept;
    }
    return imgData;
}

export default {
  name: "QrScanner",
  data()
  {
    return {
      animationFrame: null,
      canvas: null,
      video: null,
      lastScan: new Date()
    }
  },
  methods: {
    destroy()
    {
      cancelAnimationFrame(this.animationFrame);
      this.animationFrame = null;
      this.canvas = null;

      if(this.video)
      {
        this.video.pause();
        this.video.removeAttribute("src");
        this.video.load();
      }

      this.video = null;
      this.$refs.modal.classList.remove("is-active");
    },
    tick: function()
    {
      if (this.video && this.video.readyState === this.video.HAVE_ENOUGH_DATA && this.lastScan >= 500)
      {
        this.$refs.canvas.height = this.video.videoHeight;
        this.$refs.canvas.width = this.video.videoWidth;
        const width = this.video.videoWidth;
        const height = this.video.videoHeight;
        this.canvas.drawImage(this.video, 0, 0, this.$refs.canvas.width, this.$refs.canvas.height);
        this.canvas.fillStyle = "rgba(80, 80, 80, 0.65)";
        this.canvas.fillRect(0, 0, width, height * 0.3);
        this.canvas.fillRect(0, height * 0.3, width * 0.3, height * 0.4);
        this.canvas.fillRect(width * 0.7, height * 0.3, width, height * 0.4);
        this.canvas.fillRect(0, height * 0.7, width, height);
        const imageData = contrastImage(this.canvas.getImageData(0, 0, this.$refs.canvas.width, this.$refs.canvas.height), 20);
        const code = jsQR(imageData.data, imageData.width, imageData.height,
        {
          inversionAttempts: "dontInvert",
        });
        this.lastScan = new Date();

        if (code)
        {
          this.drawLine(code.location.topLeftCorner, code.location.topRightCorner, "#FF3B58");
          this.drawLine(code.location.topRightCorner, code.location.bottomRightCorner, "#FF3B58");
          this.drawLine(code.location.bottomRightCorner, code.location.bottomLeftCorner, "#FF3B58");
          this.drawLine(code.location.bottomLeftCorner, code.location.topLeftCorner, "#FF3B58");
          
          this.$parent.qrResult(code.data);
          this.destroy();
        }
      }
      
      this.animationFrame = requestAnimationFrame(this.tick);
    },
    drawLine: function(begin, end, color) {
      this.canvas.beginPath();
      this.canvas.moveTo(begin.x, begin.y);
      this.canvas.lineTo(end.x, end.y);
      this.canvas.lineWidth = 4;
      this.canvas.strokeStyle = color;
      this.canvas.stroke();
    },
    scanQr: async function()
    {
      this.video = document.createElement("video");
      this.canvas = this.$refs.canvas.getContext("2d");

      // Use facingMode: environment to attemt to get the front camera on phones
      try
      {
        
        const stream = await navigator.mediaDevices.getUserMedia({ video: { facingMode: "environment" } });
        this.video.srcObject = stream;
        this.video.setAttribute("playsinline", true); // required to tell iOS safari we don't want fullscreen
        this.video.play();
        this.animationFrame = requestAnimationFrame(this.tick);
        this.$refs.modal.classList.add("is-active");
      }

      catch(error)
      {
        this.destroy();
        alert(this.$t("NoCamera"));
        return;
      }
    }
  }
};
</script>